// Common form label styles to ensure consistency across the application
export const formLabelStyles = "text-sm font-medium text-muted-foreground"; 